import { captureException } from '@sentry/core';

import { waitForContentAPI } from '@canvas/frame-api/host-api/host-frame-context';

import { type Recyclable } from '../types';

/**
 * Recyclable that tells the host to clear published referencing via {@link waitForContentAPI}
 * when bridge identity recycles. Uses `skipInitialSetup` so the first `registerRecyclableModules` pass does
 * not run `setup`. Usually registered after clear-flags and before feature recyclables in
 * {@link registerRecyclableModules}.
 */
export function createPublishEmptyDatabaseReferencingRecyclable(): Recyclable {
  return {
    skipInitialSetup: true,
    setup() {
      waitForContentAPI()
        .then((contentAPI) => {
          contentAPI?.publishDatabaseReferencingContent?.([]);
        })
        .catch((error) => {
          captureException(error);
        });
    },
    dispose() {},
  };
}
